import { render, staticRenderFns } from "./Previews.vue?vue&type=template&id=a777abb2&scoped=true"
import script from "./Previews.vue?vue&type=script&lang=js"
export * from "./Previews.vue?vue&type=script&lang=js"
import style0 from "./Previews.vue?vue&type=style&index=0&id=a777abb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a777abb2",
  null
  
)

export default component.exports